<!--
  --
  -- 車両カード
  --
  -->
<template>
  <v-card>
    <v-card-title>車両</v-card-title>

    <v-card-text>
      <!-- 車両名 -->
      <div class="mb-2">
        <small class="mr-1">{{car.maker}}</small>
        <span class="text--primary font-weight-bold">{{car.name}}</span>
      </div>

      <v-row no-gutters align="center">
        <v-col cols="4">
          <v-img
            :src="car.image"
            :aspect-ratio="4/3"
            contain
          />
        </v-col>
        <v-col cols="8" class="pl-4 text-caption">
          <div>{{car.typeName}}</div>
          <div>
            <span>{{summary}}</span>
          </div>
          <div v-html="tags"></div>
        </v-col>
      </v-row>

      <div
        v-show="enableCar24Flg"
        class="confirm_vkey_link"
      >
        <a :href="'/reserve/res/' + orgcode + '/vkey.pdf'">24時間貸出車両について</a>
      </div>

    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CCarCard',

  computed: {
    car () {
      return this.getters['book/car']
    },

    orgcode () {
      return this.getters['org/code']
    },

    enableCar24Flg () {
      let enableCar24Flg = false
      if (this.car.attributes.keykey === 1 || this.car.attributes.vkey === 1) {
        enableCar24Flg = true
      }
      return enableCar24Flg
    },

    summary () {
      const summary = []

      const attrs = this.car.attributes

      if (attrs.cc > 0) {
        summary.push(`${attrs.cc} cc`)
      }
      if (attrs.fuel) {
        summary.push(attrs.fuel)
      }
      if (attrs.seats > 0) {
        summary.push(`乗車${attrs.seats}名`)
      }
      if (attrs.bed > 0) {
        summary.push(`就寝${attrs.bed}名`)
      }

      return summary.join(' / ')
    },

    tags () {
      const tags = []

      const attrs = this.car.attributes

      if (attrs.vkey || attrs.keykey) {
        tags.push('24h貸出')
      }

      tags.push(attrs.smoke ? '喫煙' : '禁煙')
      tags.push(attrs.mission ? 'MT' : 'AT')
      if (attrs.drive === 1) {
        tags.push('4WD')
      }

      if (attrs.etc) {
        tags.push('ETC')
      }
      if (attrs.navi) {
        tags.push('カーナビ')
      }
      if (attrs.studless) {
        tags.push('スタッドレス可')
      }
      if (attrs.tags) {
        tags.push(...attrs.tags)
      }

      return this.tags_html(tags)
    }
  },

  methods: {
    font_color_class () {
      let ClassName = ''
      if (this.isDarkColor('primary') === true) {
        ClassName = 'Attributes_Dark'
      } else {
        ClassName = 'Attributes_Bright'
      }
      ClassName = 'Attributes_Dark'
      return ClassName
    },

    tags_html (tags) {
      // 配列かどうか
      if (Array.isArray(tags)) {
      } else {
        return
      }

      // テーマ色設定
      const FontColor = this.font_color_class()
      const SpanTag = '<span class="AttributesIcon ' + FontColor + ' primary">'

      // HTMLタグに変換
      let HTML = ''
      for (let i = 0; i < tags.length; i++) {
        HTML = HTML + SpanTag + tags[i] + '</span>'
      }

      return HTML
    }
  }
}
</script>
